<script>
  import lodash from 'lodash';
  import TrendChart from './TrendChart.vue';
  import DataMethods from '../../utils/DataMethods.js';

  export default {
    name: 'TestsPerPhysician',
    mixins: [DataMethods],
    extends: TrendChart,
    data() {
      return {
        chartId: 'testsPerPhysician',
        fields: [
          'tests_ige',
          'tests_mqt',
          'tests_pricks',
          'tests_sticks',
        ],
      };
    },
    computed: {
      actualValueRaw() {
        return lodash.map(this.curYear, (month) => {
          return this.calcFunction(month);
        });
      },
      benchmarkValueRaw() {
        return lodash.map(this.benchmarkYear, (month) => {
          return this.calcFunction(month);
        });
      },
      previousValueRaw() {
        return lodash.map(this.prevYear, (month) => {
          return this.calcFunction(month);
        });
      },
    },
    methods: {
      calcFunction(month) {
        return this.round(lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(month[field])
        }, 0)/parseInt(month['num_physicians_and_midlevel']), 2);
      },
    },
  };
</script>
